import constructionDesktop from '@/assets/illustrations/industry card construction desktop.svg'
import constructionMobile from '@/assets/illustrations/industry card construction mobile.svg'
import eventsDesktop from '@/assets/illustrations/industry card events festivals desktop.svg'
import eventsMobile from '@/assets/illustrations/industry card Events mobile.svg'
import tvFilmDesktop from '@/assets/illustrations/industry card TV FIlm desktop.svg'
import tvFilmMobile from '@/assets/illustrations/industry card TV Film mobile.svg'
import facilitiesDesktop from '@/assets/illustrations/industry card FM desktop.svg'
import facilitiesMobile from '@/assets/illustrations/industry card FM mobile .svg'

export interface Industry {
    key: string;
    /** Title Case label, used in the dropdown listbox. */
    pickerLabel: string;
    /** Lowercase fragment for "What [industry] love about unimo." */
    headlineFragment: string;
    subheadline: string;
    cta: string;
    illustration: {
        desktop: string;
        mobile: string;
    };
}

// Copy source: content/unimo-messaging.md, "Industry panel (homepage + industry pages)"
export const INDUSTRIES: Industry[] = [
    {
        key: 'construction',
        pickerLabel: 'Construction Teams',
        headlineFragment: 'construction teams',
        subheadline: 'Digital twins built in minutes. Live data, from day one.',
        cta: 'Dig in',
        illustration: { desktop: constructionDesktop, mobile: constructionMobile },
    },
    {
        key: 'events',
        pickerLabel: 'Events Teams',
        headlineFragment: 'events teams',
        subheadline: 'Curfew countdowns and evidence packs, sorted before anyone asks.',
        cta: 'Sound check',
        illustration: { desktop: eventsDesktop, mobile: eventsMobile },
    },
    {
        key: 'tv-film',
        pickerLabel: 'TV & Film Crews',
        headlineFragment: 'TV & film crews',
        subheadline: 'Albert-ready, without the admin.',
        cta: 'Action',
        illustration: { desktop: tvFilmDesktop, mobile: tvFilmMobile },
    },
    {
        key: 'facilities',
        pickerLabel: 'Facilities Managers',
        headlineFragment: 'facilities managers',
        // DRAFT in content/unimo-messaging.md — built without the golden-burden source material, revisit.
        subheadline: "Know what's about to go wrong, not what already did.",
        cta: 'Walk the floor',
        illustration: { desktop: facilitiesDesktop, mobile: facilitiesMobile },
    },
]
